import { render } from "./BaseError.vue?vue&type=template&id=94b83840"
import script from "./BaseError.vue?vue&type=script&lang=js"
export * from "./BaseError.vue?vue&type=script&lang=js"

import "./BaseError.vue?vue&type=style&index=0&id=94b83840&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__